import React from "react";
import Header3 from "../Header/Header3";

import "./globe.css";
// import FileLoad from './FileLoad/filedownload2'
// const googleImgUrl = `http://124.16.188.131:8087/api/tms/publish_store_mapbox/{z}/{reverseY}/{x}`
// const googleImgUrl = "http://t0.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=img_w&tk=8f233fb615a708bd1505fe695748b11f"
const googleImgUrl = "/TianDiTu/DataServer?T=img_w&x={x}&y={y}&l={z}&tk=007da76f0d257e291f886de0871f6ea6"
const googleImgUrlzj = "/TianDiTu/DataServer?x={x}&y={y}&l={z}&T=cva_w&tk=007da76f0d257e291f886de0871f6ea6"

const googleMapUrl = `${window.sliceServersUrl ? window.sliceServersUrl.earthBaseUrl : null}/map_data/googlemap/{z}/{x}/{y}.png`
// const googleImgUrl = "https://mt1.google.cn/vt/lyrs=s&x={x}&y={y}&z={z}";
// const googleImgUrl = "http://mt2.google.cn/vt/lyrs=y&scale=2&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}";//含标注
// const googleImgUrl3 = "http://mt2.google.cn/vt/lyrs=s&scale=2&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}";//无标注
// const googleImgUrl4 = "http://mt2.google.cn/vt/lyrs=m&scale=2&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}";//地图

// const TdtImgUrl = "http://t0.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=img_w&tk=6c4e74345073b248fdf10ba82480558e"
// const TdtDMUrl = "http://t0.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=cva_w&tk=6c4e74345073b248fdf10ba82480558e"

const TdtImgUrl = "http://t0.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=img_w&tk=8f233fb615a708bd1505fe695748b11f"
const TdtDMUrl = "http://t0.tianditu.gov.cn/DataServer?x={x}&y={y}&l={z}&T=cva_w&tk=8f233fb615a708bd1505fe695748b11f"
// const TdtImgUrl = "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={x}&TILECOL={y}&tk=8f233fb615a708bd1505fe695748b11f"
// const TdtDMUrl = "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={x}&TILECOL={y}&tk=8f233fb615a708bd1505fe695748b11f"
// // h 街道图
// m 街道图
// p 街道图
// r 街道图
// s 影像无标注
// t 地形图
// y 影像含标注
export default class Globe extends React.Component {

  // 初始化地球
  // earthCreated = () => {

  //   // var script1 = document.createElement("script")
  //   // // script1.src = "./Build/GeoVis.js"
  //   // script1.src = `http://${global.geovisIp}:8099/Build/GeoVis.js`
  //   // // script1.src = "/server2/build/Build/GeoVis.js"
  //   // document.querySelector("body").appendChild(script1)

  //   // {
  //   //   var script2 = document.createElement("script")
  //   //   // "https://cdn.jsdelivr.net/npm/geotiff"
  //   //   script2.src = "./Build/Workers/geotiff.bundle.min.js"
  //   //   // script2.src = "https://cdn.jsdelivr.net/npm/geotiff"
  //   //   // script1.src = "/server2/build/Build/GeoVis.js"
  //   //   document.querySelector("body").appendChild(script2)
  //   // }


  //   // console.log(window.GeoVis)    //undefined
  //   // 1.解决异步加载GeoVis和DrawHelper问题
  //   new Promise(resolve => {
  //     var interGeo = setInterval(function () {
  //       if (window.GeoVis) {
  //         clearInterval(interGeo)
  //         resolve()
  //       }
  //     }, 500)
  //   }).then(function () {
  //     if (!window.GeoVis.Earth)
  //       return;
  //     window.earth = new window.GeoVis.Earth("earth", {
  //       scene: {
  //         scene3DOnly: false
  //       },
  //       shouldAnimate: true
  //     })



  //     var script2 = document.createElement("script")
  //     // script2.src = "/server2/build/Build/DrawHelperSimple.js"
  //     script2.src = "./Build/DrawHelperSimple.js"
  //     document.querySelector("body").appendChild(script2)

  //     return new Promise(resolve => {
  //       var interDraw = setInterval(function () {
  //         if (window.DrawHelper) {
  //           clearInterval(interDraw)
  //           resolve()
  //         }
  //       }, 100)
  //     })
  //   }).then(function () {
  //     try {
  //       const DrawHelper = window.DrawHelper;
  //       window.Types = DrawHelper.Types
  //       if (DrawHelper) {
  //         if (window.earth || window.DrawHelper) {
  //           window.drawHelper = new window.DrawHelper(window.earth)
  //         }
  //         else {
  //           alert("导入DrawHelper失败")
  //         }
  //         // console.log(drawHelper)
  //       } else {
  //         alert("导入DrawHelper失败")
  //       }

  //       // 
  //       // window.layer = new window.GeoVis.TileLayer(googleImgUrl, {
  //       //   projection: 'EPSG:900913'
  //       // }).addTo(window.earth.layers)

  //       window.layer = new window.GeoVis.TileLayer(googleMapUrl, {
  //         projection: 'EPSG:900913'
  //       }).addTo(window.earth.layers)
  //       window.layer = new window.GeoVis.TileLayer(googleImgUrl, {
  //         projection: 'EPSG:900913'
  //       }).addTo(window.earth.layers)
  //       // window.earth.camera.flyTo({
  //       //   destination: new window.GeoVis.Cartesian3.fromDegrees(111, 30, 1e7)
  //       // })
  //     } catch (error) {
  //       console.log(error);//偶尔在球尚在加载中切换组件，会导致出错，之后谁有机会可以看看怎么弄，暂时搁置
  //     }
  //   })
  // }

  //提示————最好不要在此处操作dom添加GeoVis相关文件，因为该create函数会随本组件存在多次加载卸载情况，可能会导致许多不明问题。目前具体问题有贴tiff和png等影像时会导致球卡死
  earthCreated = () => {
    return new Promise(resolve => {
      var interGeo = setInterval(function () {
        if (window.Geovis) {
          clearInterval(interGeo)
          resolve('11')
        }
      }, 100)
    }).then(function () {
      // if (!window.earth) {
      //     message.error("地球尚未构建！");
      //     return;
      // }
      try {
        if (!window.earth)
          return;
        window.earth = new window.Geovis.GvViewer("earth", {
          scene: {
            sceneModePicker: true
          },
          shouldAnimate: true,
          timeline: true,
          animation: true
        })
        document.getElementsByClassName("cesium-viewer-toolbar")[0].style.display = "none"
        document.getElementsByClassName("cesium-viewer-timelineContainer")[0].style.display = "none"
        document.getElementsByClassName("cesium-viewer-animationContainer")[0].style.display = "none"
        // var script2 = document.createElement("script")
        // script2.src = "./Build/DrawHelper.js"
        // document.querySelector("body").appendChild(script2)
        window.earth.imageryLayers._layers[0].show = false
        window.earth.imageryLayers.addImageryProvider(
          new window.Geovis.UrlTemplateImageryProvider({
            url: googleImgUrl
          })
        )
        window.earth.imageryLayers.addImageryProvider(
          new window.Geovis.UrlTemplateImageryProvider({
            url: googleImgUrlzj
          })
        )
      } catch (error) {
        console.log(error);
      }


      //   return new Promise(resolve => {
      //     var interLayerMap = setInterval(function () {
      //       if (window.Geovis) {
      //         clearInterval(interLayerMap)
      //         resolve('22')
      //       }
      //     }, 100)
      //   })
      // }).then(function () {
      //   try {
      //     // const DrawHelper = window.DrawHelper;
      //     // window.Types = DrawHelper.Types
      //     // window.drawHelper = new window.DrawHelper(window.earth)
      //     // if (DrawHelper && !window.drawHelper) {
      //     // window.drawHelper = new window.DrawHelper(window.earth)
      //     //   // console.log(drawHelper)
      //     // } else {
      //     //   // alert("导入DrawHelper失败")
      //     // }
      //     // window.layer = new window.GeoVis.TileLayer(TdtImgUrl, {
      //     // projection: 'EPSG:900913'
      //     // }).addTo(window.earth.layers)
      //     // window.layer = new window.GeoVis.TileLayer(TdtDMUrl, {map.url
      //     // projection: 'EPSG:900913'
      //     // }).addTo(window.earth.layers)
      //     // window.earth.camera.flyTo({
      //     //   destination: new window.GeoVis.Cartesian3.fromDegrees(111, 30, 1e7)
      //     // })
      //     // debugger
      //     // window.layer = new window.GeoVis.TileLayer(googleMapUrl, {
      //     //   projection: 'EPSG:900913'
      //     // }).addTo(window.earth.layers)
      //     // window.layer = new window.GeoVis.TileLayer(googleImgUrl, {
      //     //   projection: 'EPSG:900913'
      //     // }).addTo(window.earth.layers)
      //   } catch (error) {
      //     console.log(error)
      //   }
    })

  }
  async componentDidMount() {
    // 执行上面函数
    await this.earthCreated()
    if (this.props.showFps) {
      window.earth.scene.debugShowFramesPerSecond = true
    }
    if(this.props.morphTo3D) {
      window.earth.scene.morphTo3D(0);
    }

    if(this.props.morphTo2D) {
      window.earth.scene.morphTo2D(0);
    }

    if(this.props.morphToColumbusView) {
      window.earth.scene.morphToColumbusView(0);
    }
  }

  // 该组件取消时关掉 window.earth
  componentWillUnmount() {
    try {
      window.earth && window.earth.destroy()
    } catch (error) {
      // alert(error)
    }
  }

  render() {
    return (
      <React.Fragment>
        <div id="earth" />
      </React.Fragment>
    );
  }
}




